<template>
  <div>
    <div class="diagnose">
      <el-row>
        <h1 style="margin-top:180px;">生活习惯检查</h1>
      </el-row>
    </div>
    <div class="content">
      <el-row>
          <el-col :span="18" offset=3><div class="grid-content bg-purple"><h2 class="crumb">检测一下自己的生活习惯会否得痛风的可能</h2></div></el-col>
      </el-row>
      <el-row style="margin-bottom: 30px;">
        <el-col :span="18" offset=3 style="border:1px solid #ccc">
          <el-checkbox-group v-model="form" size="small" class="fldys-text"  @change="formChange">
            <el-checkbox name="fulicheckbox" v-for="(item,index) in foptions" :key="index" :label="index" size='large' border>{{ item.value }}</el-checkbox>
          </el-checkbox-group>
          <el-button type="primary" :loading="bloading" @click="submit">提交</el-button>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'habits',
  data () {
    return {
      bloading: false,
      score: 0,
      form: [],
      foptions: [
        { value: '家族里有人患有痛风', count: 1 },
        { value: '喜食内脏、鱼、肉类、海鲜、浓汤火锅等高嘌呤的食物', count: 1 },
        { value: '喜食肥肉、油炸、糖果等食品', count: 1 },
        { value: '喜食花生、核桃等坚果', count: 1 },
        { value: '嗜酒。', count: 1 },
        { value: '饮食不节，应酬频繁', count: 1 },
        { value: '三餐不定时定量', count: 1 },
        { value: '体型肥胖', count: 1 },
        { value: '长期使用解热镇痛药、利尿药、抗结核药、哮喘用药、肿瘤化疗药物', count: 1 },
        { value: '已经检查发现血压、血糖、血脂升高，或已经确诊高血压、糖尿病和高血脂', count: 1 },
        { value: '已经检查发现肾功能有问题', count: 1 },
        { value: '情绪容易波动，遇事不沉着，经常不安', count: 1 },
        { value: '事务繁忙，经常操劳', count: 1 },
        { value: '不爱喝水', count: 1 },
        { value: '非常喜欢体育锻炼，经常汗流浃背', count: 1 }
      ]
    }
  },
  methods: {
    formChange: function () {
      let sadd = 0
      for (var i = 0; i < this.form.length; i++) {
        var temp = this.form[i]
        sadd += this.foptions[temp].count
      }
      this.score = sadd
    },
    submit: function () {
      let msg = ''
      console.log(this.score)
      if (this.score < 3) {
        msg = '您的生活习惯比较好，请继续保持。'
      } else if (this.score < 7) {
        msg = '您具有患痛风的高危因素，需要定期检查。'
      } else {
        msg = '您可能已经罹患痛风或高尿酸血症，请尽快就医诊治。'
      }
      this.$alert(msg, '诊断结果', {
        confirmButtonText: '确定',
        customClass: 'message-check-2'
      })
    }
  }
}
</script>

<style scoped>
body {
  width: 100%;
  margin:0 0;
  padding:0 0;
}
#App {
  width: 100%;
  margin:0 0;
  padding:0 0;
}
.diagnose {
  height: 400px;
  background-size: cover;
  position: relative;
  background:url('../assets/food_bg_1.jpg');
  background-repeat: no-repeat;
  background-position: center center;
}
.diagnose h1{color:#eee;letter-spacing:12px;font-family: "微软雅黑";}
.el-checkbox__label {
  display: block;
}
.el-checkbox {
  margin-top:15px;
  margin-bottom:15px;
  height:auto;
}
.el-checkbox, .el-checkbox__input {
  white-space: normal;
}
.el-checkbox.is-bordered.el-checkbox--small {
  height:auto;
}
.el-button {
  margin-bottom:15px;
}
</style>
